var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.icon)?_c('i',{class:['fa', _vm.icon]}):_vm._e(),_vm._v(" "),(_vm.distance === 1)?_c('span',{class:{ 'space-left': _vm.icon }},[_vm._v(_vm._s(_vm.distance)+" mile")]):_c('span',{class:{ 'space-left': _vm.icon }},[_vm._v(_vm._s(_vm.distance)+" miles")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c71503e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Distance.vue
// module id = 263
// module chunks = 0 1 5